import { Box } from "@mui/material";
import { getDay } from "date-fns";
import { eachDayOfInterval } from "date-fns/fp";
import { chain, filter, map, pipe } from "ramda";
import { useContext, useEffect, useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { parseWeek } from "../../../components/Forms";
import { I18nContext } from "../../I18n/I18nProvider";
import { Loaders, QueryRenderer } from "../../QM/QueryRenderer";
import { useResetForm } from "../CoachProfile/CoachProfileSettings";
import { DAY_NAMES, INDEX_TO_DAY } from "../constants";
import { sortIntervals } from "../sortIntervals";
import { splitInterval } from "../splitInterval";
import { dayRangesName, enabledName } from "./AvailabilitySettings";
import { DaySlots } from "./DaySlots";

const to = (events = [], { i18n } = {}) => {
  return DAY_NAMES.reduce((acc, dayName) => {
    const dayRanges = pipe(
      chain(splitInterval),
      filter(({ from }) => from?.day === dayName),
      sortIntervals,
    )(events);
    // console.log("[CustomAvailabilityForm.to]", { dayName, events, dayRanges, });

    return {
      ...acc,
      [enabledName(dayName)]: !!dayRanges.length,
      [dayRangesName(dayName)]: !!dayRanges.length
        ? pipe(
            chain(({ from, to }) => [from, to]),
            map(({ day, time }) => new Date().setHours(...time.split(":"))),
          )(dayRanges)
        : [
            new Date().setHours(9, 0, 0), // 09:00:00
            new Date().setHours(17, 0, 0), // 17:00:00
          ],
    };
  }, {});
};

export const CustomAvailabilityForm = ({
  form,
  recurringAvailabilityQuery,
}) => {
  const { i18n } = useContext(I18nContext);
  const days = useMemo(
    () => eachDayOfInterval(parseWeek({ i18n }, new Date())),
    [i18n],
  );
  const { resetForm, resetting } = useResetForm({
    initialResetting: true,
    form,
  });

  useEffect(() => {
    const initialValues = to(recurringAvailabilityQuery.data || {}, { i18n });
    resetForm(initialValues, {
      // keepDirty: false,
    });
  }, [recurringAvailabilityQuery.data]);

  if (recurringAvailabilityQuery.error)
    return <QueryRenderer error={recurringAvailabilityQuery.error} />;
  // reset of MUI Autocomplete
  if (!recurringAvailabilityQuery.data || resetting)
    return <Loaders.CircularBlock spaced />;

  return (
    <Box>
      <FormProvider {...form}>
        {days.map((date) => (
          <DaySlots key={date} dayName={INDEX_TO_DAY[getDay(date)]} />
        ))}
      </FormProvider>
    </Box>
  );
};
